import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

export type Branches = {
  branches: string[];
};

const useBranches = (appSlug: string, opts?: UseMonolithApiQueryOptions<Branches, unknown>) => {
  return useMonolithApiQuery<Branches, unknown>(['git-branches', appSlug], `/app/${appSlug}/git-branches`, opts);
};

export default useBranches;
